import React from 'react';
import { format } from 'date-fns';

import Picture from '../Picture';
import getArticleLabel from '../../modules/getArticleLabel';
import IMAGE_SIZE from '../../constants/image-size.constants';
import Link from 'next/link';
import type { TypeArticleWithoutUnresolvableLinksResponse } from '@/contentful/types';

type FullPreviewProps = {
  content: TypeArticleWithoutUnresolvableLinksResponse;
};

const FullPreview = (props: FullPreviewProps) => {
  const { content } = props;

  return (
    <Link
      prefetch={false}
      href={`/articles/${content.fields.slug}`}
      className='standard-article-card'
    >
      <div className='standard-article-card__inner'>
        {content.fields.articleThumbnail ? (
          <div className='standard-article-card__picture-container'>
            <div className='standard-article-card__picture-main'>
              <Picture
                image={content.fields.articleThumbnail}
                width={IMAGE_SIZE.ARTICLE__THUMBNAIL}
              />
            </div>
          </div>
        ) : (
          <div className='standard-article-card__media-container'>
            <div
              className='standard-article-card__media-main'
              style={{
                backgroundImage: 'url("/static/imgs/trending/trending.jpg")'
              }}
            >
              {}
            </div>
          </div>
        )}
        <div className='standard-article-card__main'>
          <div className='standard-article-card__body'>
            {getArticleLabel(content) && (
              <div className='standard-article-card__category'>
                <span className='standard-article-card__category-label'>
                  {getArticleLabel(content)}
                </span>
                {content.fields.publishedAt &&
                  format(new Date(content.fields.publishedAt), 'dd MMM yy')}
              </div>
            )}
            <h2 className='standard-article-card__title'>
              {content.fields.articleName}
            </h2>
            <div className='standard-article-card__info'>
              {content.fields.authors && content.fields.authors.length > 0 && (
                <div className='standard-article-card__author'>
                  {content.fields.authors
                    .map(
                      (author) =>
                        `${author?.fields.firstName} ${author?.fields.lastName}`
                    )
                    .join(' AND ')}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default FullPreview;
